export default {
  data: () => ({
    layersLoader: {},
  }),
  methods: {
    addLayersLoaderSource(id, name, source) {
      if (this.layersLoader[id]) {
        return;
      }
      this.layersLoader = {...this.layersLoader, ...{[id]: {id, name, loading: 0}}};
      source.on('tileloadstart', () => {
        this.layersLoader[id].loading += 1;
      })
      source.on('tileloadend', () => {
        this.layersLoader[id].loading -= 1;
      });
      source.on('tileloaderror', () => {
        this.layersLoader[id].loading -= 1;
      });
    }
  }
}